import * as React from 'react';
import { CSSTransition } from 'react-transition-group';
import * as s from './Reveal.module.scss';
import * as fadeStyles from './Reveal.fadeStyles.module.scss';
import * as liftStyles from './Reveal.liftStyles.module.scss';
import * as dropStyles from './Reveal.dropStyles.module.scss';

type Props = {
  fade?: boolean;
  lift?: boolean;
  drop?: boolean;
};

class Reveal extends React.Component<Props> {
  state = {
    show: false,
  };

  revealOnScroll = () => {
    if (this.elementRef) {
      const isVisible =
        -100 > this.elementRef.getBoundingClientRect().top - window.innerHeight;

      if (isVisible) {
        this.setState({ show: true });
      }
    }
  };

  componentDidMount() {
    window.addEventListener('scroll', this.revealOnScroll);

    this.revealOnScroll();

    // Fix initial reflow issue
    setTimeout(this.revealOnScroll, 500);
    setTimeout(this.revealOnScroll, 1000);
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.revealOnScroll);
  }

  elementRef?: any;

  render() {
    const { children, fade, lift, drop } = this.props;

    let revealStyles = {};

    if (fade) {
      revealStyles = fadeStyles;
    }

    if (lift) {
      revealStyles = liftStyles;
    }

    if (drop) {
      revealStyles = dropStyles;
    }

    return (
      <div
        ref={r => {
          this.elementRef = r;
        }}
      >
        <CSSTransition
          in={this.state.show}
          timeout={1000}
          classNames={revealStyles}
        >
          <div className={s.children}>{children}</div>
        </CSSTransition>
        <div
          className={`${liftStyles.enter} ${liftStyles.enterActive} ${
            liftStyles.enterDone
          }`}
        />
      </div>
    );
  }
}

export default Reveal;
